<div class="d-flex flex-column autocomplete-mobile h-100">
  <div class="d-flex flex-column autocomplete-mobile-header">
    <div class="d-flex justify-content-between align-items-center">
      <h2 class="semi-bold">Depart date</h2>
      <img
        class="cursor-pointer"
        width="12"
        height="12"
        data-id="close-mobile"
        src="assets/icons/close_blue.svg"
        alt="close"
        (click)="hide.emit()"
      />
    </div>
    <ds-input
      autocomplete="off"
      placeholder="Search"
      data-id="filter"
      [value]="filterValue || ''"
      (valueChange)="onFilterChange($event)"
    />
  </div>

  <div class="autocomplete-mobile-body h-100">
    @if (filteredItems.length) {
      <cdk-virtual-scroll-viewport
        class="h-100"
        customVirtualScroll
        [heights]="heights"
        [paddingBottom]="4"
        [paddingTop]="4"
      >
        <div
          data-id="autocomplete-group"
          *cdkVirtualFor="let item of filteredItems; trackBy: trackByItemFn; let isLast = last"
          class="autocomplete-mobile-body-group pt-4 pb-4 d-flex flex-column g-3"
          [class.with-border]="!isLast"
        >
          @if (item.groupData && item.options.length > 1) {
            <div data-id="autocomplete-group-header" class="autocomplete-mobile-body-group-item">
              <input-field-with-autocomplete-option [option]="item.groupData" />
            </div>
          }
          @for (option of item.options; track trackByOptionFn(option)) {
            <div
              data-id="autocomplete-group-option"
              class="autocomplete-mobile-body-group-item enabled"
            >
              <input-field-with-autocomplete-option
                [option]="option"
                (click)="onSelectValue(option)"
              />
            </div>
          }
        </div>
      </cdk-virtual-scroll-viewport>
    } @else {
      @if (filterValue) {
        <div
          data-id="autocomplete-empty"
          class="d-flex align-items-center justify-content-center p-3"
        >
          <p>We couldn’t find what you were looking for.</p>
        </div>
        <img class="w-100" src="assets/images/shutterstock.webp" alt="no-data" />
      }
    }
  </div>
</div>
